export const LEASE_DECISION_WINDOW_MONTHS = 12;
export const LEASE_DECISION_WINDOW_SCOPE = `next${LEASE_DECISION_WINDOW_MONTHS}`;

export function isWithinLeaseDecisionWindow(value, asOfDate = new Date()) {
  if (!value) return false;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return false;

  // Lease dates are date-only values. Compare UTC calendar days against an
  // exact calendar-month window so the boundary matches Home's decision set.
  const start = Date.UTC(
    asOfDate.getUTCFullYear(),
    asOfDate.getUTCMonth(),
    asOfDate.getUTCDate(),
  );
  const endMonthIndex = asOfDate.getUTCFullYear() * 12
    + asOfDate.getUTCMonth()
    + LEASE_DECISION_WINDOW_MONTHS;
  const endYear = Math.floor(endMonthIndex / 12);
  const endMonth = endMonthIndex % 12;
  const lastDayOfEndMonth = new Date(Date.UTC(endYear, endMonth + 1, 0)).getUTCDate();
  const endDay = Math.min(asOfDate.getUTCDate(), lastDayOfEndMonth);
  const end = Date.UTC(endYear, endMonth, endDay);
  const decisionDay = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  return decisionDay >= start && decisionDay <= end;
}

export function hasLeaseDecisionDateInWindow(lease, asOfDate = new Date()) {
  return [lease?.endDate, lease?.breakDate].some(
    (date) => isWithinLeaseDecisionWindow(date, asOfDate),
  );
}
